export const FORM = `{
  id
  data
  partner_id
  status
  form_source
  ref_link
  lastUpdatedBy
  createdAt
  updatedAt
  lead_progress
  last_activity_time
  last_activity
  lifecycle_stage
}`
